var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimazing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9492 5.60005C12.9492 6.17995 12.4791 6.65005 11.8992 6.65005L4.54922 6.65005C3.96932 6.65005 3.49922 6.17995 3.49922 5.60005C3.49922 5.02015 3.96932 4.55005 4.54922 4.55005L11.8992 4.55005C12.4791 4.55005 12.9492 5.02015 12.9492 5.60005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 5.60005C24.5 6.17995 24.0299 6.65005 23.45 6.65005L16.1 6.65005C15.5201 6.65005 15.05 6.17995 15.05 5.60005C15.05 5.02015 15.5201 4.55005 16.1 4.55005L23.45 4.55005C24.0299 4.55005 24.5 5.02015 24.5 5.60005Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0508 14C15.0508 14.5798 14.5807 15.05 14.0008 15.05L4.55078 15.0499C3.97088 15.0499 3.50078 14.5798 3.50078 14C3.50078 13.4201 3.97088 12.95 4.55078 12.95L14.0008 12.95C14.5807 12.95 15.0508 13.4201 15.0508 14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 14C24.5 14.5799 24.0299 15.05 23.45 15.05L18.2 15.05C17.6201 15.05 17.15 14.5798 17.15 14C17.15 13.4201 17.6201 12.95 18.2 12.95L23.45 12.95C24.0299 12.95 24.5 13.4201 24.5 14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8496 22.4C10.8496 22.9799 10.3795 23.45 9.79961 23.45L4.54961 23.45C3.96971 23.45 3.49961 22.9799 3.49961 22.4C3.49961 21.8201 3.96971 21.35 4.54961 21.35L9.79961 21.35C10.3795 21.35 10.8496 21.8201 10.8496 22.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 22.4C24.5 22.9799 24.0299 23.45 23.45 23.45L14 23.45C13.4201 23.45 12.95 22.9799 12.95 22.4C12.95 21.8201 13.4201 21.35 14 21.35L23.45 21.35C24.0299 21.35 24.5 21.8201 24.5 22.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80078 5.6C9.80078 4.4402 10.741 3.5 11.9008 3.5C13.0606 3.5 14.0008 4.4402 14.0008 5.6C14.0008 6.7598 13.0606 7.7 11.9008 7.7C10.741 7.7 9.80078 6.7598 9.80078 5.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0996 14C16.0996 12.8402 17.0398 11.9 18.1996 11.9C19.3594 11.9 20.2996 12.8402 20.2996 14C20.2996 15.1598 19.3594 16.1 18.1996 16.1C17.0398 16.1 16.0996 15.1598 16.0996 14Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69922 22.4C7.69922 21.2403 8.63942 20.3 9.79922 20.3C10.959 20.3 11.8992 21.2403 11.8992 22.4C11.8992 23.5598 10.959 24.5 9.79922 24.5C8.63942 24.5 7.69922 23.5598 7.69922 22.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimazing);
export default __webpack_public_path__ + "static/media/optimazing.c956a6de734f6d219cf99f66202c27d1.svg";
export { ForwardRef as ReactComponent };